/**
 * Sort checkboxes. Pass through the Checkbox interface or your own extended Checkbox interface.
 * Key should be a string property, like "labelCopy".
 * @param {T[]} unsorted  T[]
 * @param key string
 */
export const sortCheckboxes = <T>(unsorted: T[], key: 'labelCopy' | string): T[] => unsorted.sort((a, b) => (a[key]).localeCompare(b[key]));
